'use client';

import { Suspense, type ReactNode } from 'react';
import SalesCallbackProvider from '@/components/sales-callback/SalesCallbackProvider';
import SalesCallbackSection from '@/components/sales-callback/SalesCallbackSection';
import ProductList from '../components/ProductList';
import ProductListSkeleton from '../components/ProductListSkeleton';
import type { ProductLandingPageType } from '@/types/product';

interface ProductListClientProps {
  locale: string;
  productLandingData?: ProductLandingPageType | null;
  /**
   * Streaming slot for the FAQ + enquiry block at the page bottom. The
   * lead-forms Strapi fetch happens in an async Server Component over
   * in `page.tsx` and is wrapped in `<Suspense>`, so the above-fold
   * (hero, intro, product types) paints without waiting on it.
   */
  faqSlot?: ReactNode;
}

export default function ProductListClient({
  locale,
  productLandingData,
  faqSlot,
}: ProductListClientProps) {
  return (
    <SalesCallbackProvider>
      <SalesCallbackSection mode="page">
        <Suspense fallback={<ProductListSkeleton />}>
          <ProductList
            locale={locale}
            productLandingData={productLandingData ?? null}
            faqSlot={faqSlot}
          />
        </Suspense>
      </SalesCallbackSection>
    </SalesCallbackProvider>
  );
}
